export default __webpack_public_path__ + "static/media/pause.14e4ae73.svg";